<template>
  <div>
    <span v-html="html" />
    <span
      v-if="showMarkup"
      style="font-size: smaller; font-style: italic; border: solid gray 1px"
    >
      <span v-if="swm.Markup">{{ swm.String }}</span>
      <span
        v-for="(m, l) in swm.Markup"
        :key="l"
      >
        {{ m }}
      </span>
    </span>
  </div>
</template>
<script>
export default {
  name: 'StringWithMarkup',
  props: {
    showMarkup: {
      type: Boolean,
      default: false,
    },
    swm: {
      type: Object,
      required: true,
    },
  },

  computed: {
    html() {
      if (!this.swm.Markup || !this.swm.Markup.length) return this.swm.String

      let text = this.swm.String
      const sortedMarkup = [...this.swm.Markup].sort((a, b) => b.Start - a.Start)
      for (let i = 0; i < sortedMarkup.length; i++) {
        const m = sortedMarkup[i]
        let repl
        if (m.Type === 'Icon') {
          repl = `<img src="${m.URL}" width="70" title="${m.Extra}" />`
        } else if (m.Type === 'Italics') {
          const sub = text.substring(m.Start, m.Start + m.Length)
          repl = `<i>${sub}</i>`
        } else if (m.Type === 'Superscript') {
          const sub = text.substring(m.Start, m.Start + m.Length)
          repl = `<sup>${sub}</sup>`
        } else if (m.Type === 'Subscript') {
          const sub = text.substring(m.Start, m.Start + m.Length)
          repl = `<sub>${sub}</sub>`
        } else if (m.Type === 'Color') {
          const sub = text.substring(m.Start, m.Start + m.Length)
          repl = `<span class="${m.Extra}">${sub}</span>`
        } else if (m.URL) {
          const sub = text.substring(m.Start, m.Start + m.Length)
          repl = `<a href="${m.URL}" target="_blank">${sub}</a>`
        }

        if (repl) {
          text = text.substring(0, m.Start) + repl + text.substring(m.Start + m.Length)
        }
      }

      return text
    },
  },
}
</script>

<style>
.GHSDanger {
  color: red;
}

.GHSWarning {
  color: blue;
}
</style>
